<template>
  <v-select
    id="solution-select"
    v-model="taskId"
    item-text="nome"
    item-value="tarefaId"
    :items="tasks"
    :label="`${isAT || isGov ? 'Atividades' : 'Tarefas'}`"
    :placeholder="`${isAT || isGov ? 'Atividades' : 'Tarefas'}`"
    clearable
    @change="$emit('changeTask', taskId)"
  >
    <template slot="no-data">
      Nenhuma {{ isAT ? "Atividade" : "Tarefa" }} retornada
    </template>
  </v-select>
</template>

<script>
import { taskAPI } from "@/modules/task";
import { mapActions, mapGetters } from "vuex";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppCityTaskCombobox",
  props: ["filter", "filterTasks", "tasksId"],
  data() {
    return {
      tasks: [],
      taskId: null,
    };
  },
  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  methods: {
    loadtasks() {
      taskAPI.list().then((res) => {
        this.tasks = res.data.sort((a, b) => compare(a, b, "nome"));
      });
    },
  },
  watch: {
    filterTasks: {
      handler(val, oldVal) {
        if (val && val.length) {
          this.tasks = val;
        }
      },
      deep: true,
    },
    tasksId: function (item) {
      this.taskId = item;
    },
  },
  mounted() {
    if (!this.filter.tasks) {
      this.loadtasks();
    } else {
      this.tasks = this.filter.tasks;
    }
    this.taskId = this.tasksId;
  },
};
</script>
